import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteUnavailabilityPayload } from '@app-store/slices/meetings/deleteUnavailability'

interface TaskAction extends Action {
    payload: IDeleteUnavailabilityPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.meetings.deleteUnavailability

function* deleteUnavailabilitySagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.delete(`/meeting/unavailable/${payload.id}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            if (payload?.sagaCB?.onSuccess) payload.sagaCB.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteUnavailabilitySaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteUnavailabilitySagaTask)
}

export default deleteUnavailabilitySaga
